import styled from "styled-components";
import Flex from "../flex";
import Box from "../box";
import Text from "../text";
import Pipe from "../pipe";
import { BatchActionsContext } from "./table-batch-actions-context";
import TableActionButton from "./table-action-button";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "table-batch-actions__Container",
  componentId: "sc-1h964v4-0"
})(["width:100%;height:48px;position:absolute;left:0;bottom:0;overflow:hidden;pointer-events:none;z-index:1;"]);
const Content = styled(Flex).withConfig({
  displayName: "table-batch-actions__Content",
  componentId: "sc-1h964v4-1"
})(["width:100%;height:48px;position:absolute;left:0;bottom:-100%;transition:bottom 0.2s ", ";border-top-left-radius:", "px;border-top-right-radius:", "px;pointer-events:auto;&[data-active=\"true\"]{bottom:0;}"], p => p.theme.transitions.easeInOutCircle, p => p.theme.radii.base, p => p.theme.radii.base);
function TableBatchActions(_ref) {
  let {
    count = 0,
    onCancel,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(BatchActionsContext.Provider, {
    value: count,
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Content, {
        p: 2,
        gap: 2,
        alignItems: "center",
        bg: "primary.base",
        "data-active": count > 0,
        children: [/*#__PURE__*/_jsxs(Text, {
          ml: 2,
          color: "white",
          ellipsis: true,
          children: [count, " ", count === 1 ? "item" : "items", " selected"]
        }), /*#__PURE__*/_jsx(Box, {
          m: "auto"
        }), children, /*#__PURE__*/_jsx(Pipe, {
          m: 0,
          height: 32,
          bg: "white"
        }), /*#__PURE__*/_jsx(TableActionButton, {
          onClick: onCancel,
          children: "Cancel"
        })]
      })
    })
  });
}
export default TableBatchActions;